"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("../../auth");
const exceptions_1 = require("../exceptions");
/**
 * Esegue la richiesta solo se il token non è scaduto.
 *
 * @export
 * @class TokenNotExpired
 */
class TokenNotExpired {
    constructor(data) {
        if (!auth_1.Auth.getAuthenticationAccessToken().isExpired()) {
            return Promise.resolve(data);
        }
        throw new exceptions_1.TokenExpired('Token as expired');
    }
}
exports.default = TokenNotExpired;
